import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import styled, { ThemeProvider } from "styled-components";
import LogoIcon from "../../assets/svg/Logo";
import { useTranslation } from "react-i18next";
import i18n from "src/shared/i18n/i18n.js";
import DayNightToggle from "react-day-and-night-toggle";
import { getDarkMode } from "src/shared/utils/DarMode";

export default function TopNavbar() {
  const { t } = useTranslation();
  const [y, setY] = useState(window.scrollY);
  const darkModeDefaultValue = getDarkMode();

  const [isDarkMode, setIsDarkMode] = useState(darkModeDefaultValue);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);
  const languageStorageKey = "selectedLanguage";

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem(languageStorageKey, language);
  };

  useEffect(() => {
    const darkModeValue = localStorage.getItem("isDarkMode");
    setIsDarkMode(darkModeValue === "true");
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    localStorage.setItem("isDarkMode", newDarkMode);
  };

  return (
    <ThemeProvider theme={{ isDarkMode }}>
      {" "}
      {/* Pass isDarkMode to ThemeProvider */}
      <>
        <Wrapper
          className=""
          style={y > 100 ? { height: "60px" } : { height: "80px" }}
          isDarkMode={isDarkMode}
        >
          <NavInner
            className="container flexSpaceCenterNavBar"
            isDarkMode={isDarkMode}
          >
            <a
              href="/"
              className="radius8"
              style={{ padding: "1px 1px", backgroundColor: "transparent" }}
            >
              <LogoIcon />
            </a>
            <UlWrapper isDarkMode={isDarkMode}>
              <li className="semiBold font15 pointer">
                <Link
                  activeClass="active"
                  style={{ padding: "10px 15px" }}
                  to="home"
                  spy={true}
                  smooth={true}
                  offset={-80}
                >
                  {t("home")}
                </Link>
              </li>
              <li className="semiBold font15 pointer">
                <Link
                  activeClass="active"
                  style={{ padding: "10px 15px" }}
                  to="Offers"
                  spy={true}
                  smooth={true}
                  offset={-80}
                >
                  {t("OffersNav")}
                </Link>
              </li>
              <li className="semiBold font15 pointer">
                <Link
                  activeClass="active"
                  style={{ padding: "10px 15px" }}
                  to="pricing"
                  spy={true}
                  smooth={true}
                  offset={-80}
                >
                  {t("Services")}
                </Link>
              </li>
              <li className="semiBold font15 pointer">
                <Link
                  activeClass="active"
                  style={{ padding: "10px 15px" }}
                  to="projects"
                  spy={true}
                  smooth={true}
                  offset={-80}
                >
                  {t("projects")}
                </Link>
              </li>
            </UlWrapper>
            <UlWrapperRight className="flexNullCenter" isDarkMode={isDarkMode}>
              <li className="semiBold font15 pointer flexCenter">
                <a
                  href="/delivery"
                  className="radius8"
                  style={{
                    padding: "10px 15px",
                    backgroundColor: "#eac418",
                    width: "190px",
                    textDecoration: "none",
                    color: "black",
                  }}
                >
                  {t("TarifsetRéservation")}
                </a>
              </li>
            </UlWrapperRight>
            <LanguageButtonsWrapper>
              <LanguageButton
                onClick={() => changeLanguage("en")}
                isDarkMode={isDarkMode}
              >
                EN
              </LanguageButton>
              <LanguageButton
                onClick={() => changeLanguage("fr")}
                isDarkMode={isDarkMode}
              >
                FR
              </LanguageButton>
            </LanguageButtonsWrapper>
            <DayNightToggles>
              <DayNightToggle onChange={toggleDarkMode} checked={isDarkMode} />
            </DayNightToggles>
          </NavInner>
        </Wrapper>
      </>
    </ThemeProvider>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: ${(props) => (props.isDarkMode ? "#253237" : "#fff")};
  color: ${(props) => (props.isDarkMode ? "#fff" : "#000")};
  transition: height 0.3s ease-in-out;
  @media (max-width: 760px) {
    height: ${(props) => (props.isScrolled ? "60px" : "80px")};
  }
`;

const NavInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${(props) => (props.isDarkMode ? "#253237" : "#fff")};
  color: ${(props) => (props.isDarkMode ? "#fff" : "#000")};
  transition: height 0.3s ease-in-out;

  @media (max-width: 760px) {
    height: ${(props) => (props.isScrolled ? "60px" : "80px")};
  }
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;

const UlWrapper = styled.ul`
  display: flex;
  color: ${(props) => (props.isDarkMode ? "#fff" : "#000")};
  @media (max-width: 760px) {
    display: none;
  }
`;

const UlWrapperRight = styled.ul`
  border-radius: 19px;
  background-color: ${(props) =>
    props.isDarkMode ? "#fff" : "rgb(240 240 240)"};
  color: ${(props) => (props.isDarkMode ? "#000" : "#fff")};
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

  @media (max-width: 760px) {
    display: none;
  }
`;

const LanguageButton = styled.div`
  cursor: pointer;
  color: ${(props) => (props.isDarkMode ? "white" : "black")};
`;

const LanguageButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 85px;
  @media (max-width: 760px) {
    margin-right: 15px;
  }
`;


const DayNightToggles = styled.div`
  @media (max-width: 760px) {
    position: relative;
    height: 32px;
    width: 80px;
    right: 22px;  
  }
`;
